import store from '../store';
export const manage = [
  {
    path: '/manage',
    name: 'Manage',
    component: () => import('../views/manage/manage-list'),
    meta: {
      authorizationLimit: false,
      addText: '添加用户',
      searchPlaceholder: '搜索用户名'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.login.authorizationLimit[0] != 1) {
        next({ name: 'Relic' });
      } else {
        next();
      }
    }
  }
];
